import SendItemsSelectionCart from "@components/store/cart/send-to-many/send-items-selection-cart";
import SendToMyselfCartListing from "@sharedComponents/cart/send-to-many/send-to-myself-cart-listing";

import { useSendItemsContext } from "@contexts/send-items-context";

import styles from "./main.module.scss";

const SendToMyselfCart = ({ editable, cartProductsData }) => {
  const { showSendToManyOption } = useSendItemsContext();
  return (
    <div className={styles.sendToManyBlock}>
      {showSendToManyOption && <SendItemsSelectionCart />}
      <SendToMyselfCartListing editable={editable} cartProductsData={cartProductsData} />
    </div>
  );
};
export default SendToMyselfCart;
